import { ComponentPropsWithoutRef } from 'react'
import styles from './Loader.module.css'

interface LoaderType extends ComponentPropsWithoutRef<'div'> {
  beforeText?: string,
  afterText?: string
}
export const Loader = ({ beforeText, afterText, className, ...props }: LoaderType) => {
  return (
    <>
      <div className={styles.loaderContainer}>
        {beforeText}
        <div className={styles.ldsDualRing} />
        {afterText}
      </div>
    </>
  )
}
